import React, { useState } from "react";
import BaseBage from "../BasePage";
import { getLandCover } from "../../api/FlaskAPI";
import MODISLANDCOVER from "../../assets/images/LandCover (2).png";
import CustomDropDown from "../../components/CustomDropDown";
import ESRILEGEND from "../../assets/images/Land Cover ESA .png";
import DWlegend from '../../assets/images/Dynamic-World-legend.png'
import { useParams } from "react-router-dom";
export default function LandCover() {

  const { type, index } = useParams();
  const land_cover_dataset = [
    {
      name: "MODIS",
      key: "landcover",
    },
    {
      name: "Dynamic World",
      key: "DW",
    },
    {
      name: "ESRI",
      key: "esri",
    },
    // {
    //   name: "ESA",
    //   key: "esa",
    // },
    // {
    //   name: "CCI-LC",
    //   key: "cci-lc",
    // },
  ];
  const [selectedOption, setSelectedOption] = useState("MODIS");
  const handleSelect = (event) => {
    setSelectedOption(event.target.value);
  };

  function findLandCoverKey(landcover) {
    if (landcover.name === selectedOption) {
      console.log("LC", landcover.key)
      return landcover.key
    }
    else {
      return
    }
  }
  return (
    <>
      <BaseBage
        key={index}
        monitoringKey={index}
        dataKey={index}
        endpoint={getLandCover}
        route="LandCover"
        legendImg={{
          src: selectedOption === "MODIS" ? MODISLANDCOVER :
            selectedOption === "ESRI" ? ESRILEGEND :
              DWlegend

          ,
          style: "land-cover-legend-img",
        }}
        land_cover_dataset={land_cover_dataset.find(findLandCoverKey)}
      />
    </>
  );
}
